import { ComposedTheme, createUseStyles } from '@glu/theming';

const styles = ({ formComponents, typography }: ComposedTheme) => ({
  dark: {},
  root: {
    '&$dark': {
      color: formComponents.helpText.dark.color,
    },
    color: formComponents.helpText.color,
    fontFamily: typography.fontFamily,
    fontSize: 12,
    lineHeight: 1,
    margin: [8, 0, 0],
    padding: 0,
  },
});

export default createUseStyles(styles);
